import React, { useState } from "react";
import { Link } from "react-router-dom";
import { KeyRound, MailCheck } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  if (sent) {
    return (
      <div className="max-w-md mx-auto mt-6 animate-slide-up text-center" data-testid="forgot-sent-panel">
        <MailCheck className="mx-auto text-race-volt mb-3" size={48} />
        <h1 className="font-heading text-5xl tracking-tight mb-2">CHECK YOUR INBOX</h1>
        <p className="text-race-sub text-sm mb-6">
          If <span className="text-race-txt font-mono">{email}</span> is registered, we've sent a link to reset your password. It expires in 15 minutes.
        </p>
        <Link to="/login" data-testid="forgot-back-login"
          className="inline-block bg-race-red hover:bg-race-redhover text-race-bg font-heading text-2xl tracking-wide px-8 py-3 rounded-sm transition-colors">
          Back to sign in
        </Link>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto mt-6 animate-slide-up" data-testid="forgot-password-form">
      <div className="flex flex-col items-start gap-3 mb-6">
        <KeyRound className="text-race-red" size={32} />
        <h1 className="font-heading text-5xl tracking-tight">FORGOT PASSWORD</h1>
        <p className="text-race-sub text-sm">Enter your email and we'll send you a link to get back on the grid.</p>
      </div>
      <form onSubmit={submit} className="bg-race-surface border border-race-line p-6 flex flex-col gap-4">
        <div>
          <label className="overline block mb-1">Email</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email"
            className="w-full bg-race-bg border border-race-line focus:border-race-red outline-none px-3 py-2.5 rounded-sm text-race-txt" />
        </div>
        <button type="submit" disabled={busy} data-testid="forgot-submit"
          className="bg-race-red hover:bg-race-redhover disabled:opacity-50 text-race-bg font-heading text-2xl tracking-wide py-3 rounded-sm transition-colors">
          {busy ? "…" : "SEND RESET LINK"}
        </button>
      </form>
      <p className="text-center text-sm text-race-sub mt-4">
        Remembered it?{" "}
        <Link to="/login" className="text-race-red hover:underline" data-testid="forgot-switch-login">Sign in</Link>
      </p>
    </div>
  );
}
